import {Injectable} from '@angular/core';
import {IContext} from "./context";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom, Observable, tap} from "rxjs";
import {CookieService} from 'ngx-cookie-service';
import TokenUtils from '../token-utils';
import {environment} from '../../../environments/environment';
import {OrganizationService} from '../../service/organization.service';
import {IOrganization} from '../../data/organization/organization.model';

@Injectable({
    providedIn: 'root'
})
// Loosely patterned around Sprint Security Context Holder.
export class SecurityContextHolder
{
    private _authenticated: boolean = false;
    private _context!: IContext;
    private _organizations!: IOrganization[];

    constructor(private http: HttpClient,
                private cookieService: CookieService,
                private organizationService: OrganizationService) {}

    get isAuthenticated(): boolean { return this._authenticated; }
    get context(): IContext { return this._context; }
    get organizations(): IOrganization[] { return this._organizations; }

    public async loadData()
    {
        const contextResponse = await firstValueFrom(this.http.get<IContext>(environment.coreApiBaseUrl + 'v1/users/me'));
        if (contextResponse) {
            this._authenticated = true;
            this._context = contextResponse;

            // Also load organization information
            const orgResponse = await firstValueFrom(this.organizationService.getMyOrganizations());
            if (orgResponse) {
                this._organizations = orgResponse;
            }
        }
    }

    public clear()
    {
      this._authenticated = false;
      TokenUtils.clearToken(this.cookieService, environment.tokenName);
      // this._context = null;
    }

    public hasAccess(tenantId: string, roles: string[]): boolean
    {
        if (this._authenticated)
        {
            for (const userTenant of this._context.userTenants)
            {
                if (userTenant.tenantId === tenantId)
                {
                    return roles.includes(userTenant.userRole);
                }
            }
        }
        return false;
    }

    public isBusinessPhoneGlobalAdmin() {
      return this.context.businessPhoneGlobalAdmin;
    }

    public getUserRole(tenantId: string) : string {
        if (this._authenticated)
        {
            for (const userTenant of this._context.userTenants)
            {
                if (userTenant.tenantId === tenantId)
                {
                    return userTenant.userRole;
                }
            }
        }
        return '';
    }

}
